/*
 * サブシステム名：
 * 機能名：受注・実績一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
// import validators from '@/rahmen/validators'

import d2fmt from '@/ddv2.library/utils/formatter'
import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
// import modals from '@/ddv2.library/modals'

import DdCustomButton from '@/components/DdCustomButton'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDropDown from '@/components/DdDropDown'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdMonthBox from '@/components/DdMonthBox'
import DdMonthBoxInside from '@/components/DdMonthBoxInside'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdSubHeader from '@/components/DdSubHeader'
import DdSwitch from '@/components/DdSwitch'
import DdTransparentButton from '@/components/DdTransparentButton'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2PRMT0030.js'

const DdTextBox = () => import('@/components/DdTextBox')
export default {
  name: 'HaishaMeisaiListEdit',
  mixins: [flowMixin],
  components: {
    VTour,
    DdCustomButton,
    DdCodeTextBox,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdMonthBox,
    DdMonthBoxInside,
    DdDateRangeBox,
    DdSpreadSheet,
    DdSubHeader,
    DdSwitch,
    DdTextBox,
    DdTransparentButton
  },
  data: () => ({
    isConditionHide: false,
    isEditCategory: false,

    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    // 検索用
    conditions: {},
    conditionDetails: [
      { key: 'unkoYmdFromTo', name: '運行日', value: 'unkoYmdFromTo', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'haishaEigyoshoId', name: '配車営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'tokuisakiId', name: '荷主', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'jomuinJininId', name: '乗務員', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstjinin' },
      { key: 'sharyoId', name: '車両', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstsharyo' },
      { key: 'juchuEigyoshoId', name: '売上営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'hacchusakiId', name: '傭車先', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'hacchusakiShaban', name: '傭車車両', value: 'hacchusakiShaban', delete: true }
    ],
    searchText: null,

    // 表示用
    headers: [],
    rows: [],

    // 表示制御
    isShowCondition: false,

    // 保存用
    selected: [],
    targetList: [],
    // 制御用運行実績ID（新規の場合は-1から減らしていく）
    wkUnkoJissekiId: 0,
    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,
    startCoachMark2: false,
    steps2: CoachMark.STEPS2,

    modeKengen: 0,

    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '60vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列固定
      freezeColumns: 4,
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: false,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: false,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 50,
      paginationOptions: [10, 20, 50, 100, 150, 200],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 運行日
    'conditions.unkoYoteiStartYmdString': function (n) {
      var unkoYmdFromTo = ![undefined, null, ''].includes(this.conditions.unkoYoteiStartYmdString) ? this.conditions.unkoYoteiStartYmdString.slice(-5) : ''
      unkoYmdFromTo = unkoYmdFromTo + (![undefined, null, ''].includes(this.conditions.unkoYoteiEndYmdString) ? '～' + this.conditions.unkoYoteiEndYmdString.slice(-5) : '')
      this.conditions.unkoYmdFromTo = unkoYmdFromTo
    },
    'conditions.unkoYoteiEndYmdString': function (n) {
      var unkoYmdFromTo = ![undefined, null, ''].includes(this.conditions.unkoYoteiStartYmdString) ? this.conditions.unkoYoteiStartYmdString.slice(-5) : ''
      unkoYmdFromTo = unkoYmdFromTo + (![undefined, null, ''].includes(this.conditions.unkoYoteiEndYmdString) ? '～' + this.conditions.unkoYoteiEndYmdString.slice(-5) : '')
      this.conditions.unkoYmdFromTo = unkoYmdFromTo
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      xlsImportMappingList: 'DDMasters/mstXlsImportMapping',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun'
    }),
    // ----------------------------------------------------------------------------------------------------
    // 検索条件用フィルタ
    // ----------------------------------------------------------------------------------------------------
    // 営業所
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 得意先
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 傭車先
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 乗務員
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 車両
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 商品
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },

    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    isMultiSaveButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const errorRows = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg === true
      })
      if (errorRows.length > 0) {
        return true
      }

      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'vwcmstsharyo', 'msthacchakuchi', 'msthinmei', 'mstshubetsu', 'msyskubun', 'mstxlsimportmapping'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        unkoYoteiStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        unkoYoteiEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        haishaEigyoshoId: indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).id,
        jomuinJininId: null,
        tokuisakiId: null,
        ninushiId: null,
        juchuEigyoshoId: null,
        haishaTantoJininId: null,
        sharyoId: null,
        hacchusakiId: null,
        sharyoGroup1: null,
        sharyoGroup2: null,
        jissekiTorokuKbn: '03',
        jissekiKakuninKbn: '03',
        haishaStatusKbn: '03',
        haishasakiKbn: '01',
        meisaiHeadFlg: false,
        mstHinmeiId: null,
        hacchusakiShaban: null
      }
      this.conditions = {
        ...initConditions,
        // 表示用
        unkoYmdFromTo: initConditions.unkoYoteiStartYmdString.slice(-5) + '～' + initConditions.unkoYoteiEndYmdString.slice(-5),
        haishaEigyoshoNm: indexeddb.getRecord(this.eigyoshoList, initConditions.haishaEigyoshoId).eigyoshoNm,
        tokuisakiNm: '',
        yoshasakiNm: '',
        jomuinJininNm: '',
        jidoshaHyojiNm: '',
        juchuEigyoshoNm: '',
        mstHinmeiNm: ''
      }
      this.searchText = ''
      this.rows = []
      this.page = 1
    },

    onClearButtonClick: function () {
      this.clear()
      this.setHeader()
    },
    clear: function () {
      this.initBindVariables()
      this.rows = []
      this.isConditionHide = false
    },
    onSearchButtonClick: function () {
      this.$nextTick(() => {
        this.searchAction(false)
      })
    },
    onRemoveConditionClick: function (itemNm) {
      this.conditions[itemNm] = null
      this.$nextTick(() => {
        this.searchAction(false)
      })
    },
    searchAction: function (noMessage) {
      this.rows = []
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2prmd0030/search', self.conditions)
              .then((data) => {
                self.setHeader()
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          const resultData = data.payload
          // 検索結果保持用にセット
          resultData.map((elem, index) => {
            // スプレッドシート用にここで編集
            elem.rowNo = index + 1
            elem.collectTrUnkoJissekiId = elem.id
            elem.editFlg = false
            elem.errFlg = false
            elem.editMode = false
            elem.relation = index === 0 ? '▼' : elem.id !== data.payload[index - 1].id ? '▼' : '△'
            // ここから表示用編集
            elem.unkoYmd = filter.dateFormatter(elem.unkoYmd)
            elem.haishaKbnNm = elem.haishaKbn === '03' ? '傭車' : '自社'
            elem.hatsuchiYmd = ![undefined, null, ''].includes(elem.hatsuchiYmd) ? filter.dateFormatter(elem.hatsuchiYmd) : ''
            elem.hatsuchiHms = ![undefined, null, ''].includes(elem.hatsuchiHms) ? (elem.hatsuchiHms).slice(0, 5) : ''
            elem.chakuchiYmd = ![undefined, null, ''].includes(elem.chakuchiYmd) ? filter.dateFormatter(elem.chakuchiYmd) : ''
            elem.chakuchiHms = ![undefined, null, ''].includes(elem.chakuchiHms) ? (elem.chakuchiHms).slice(0, 5) : ''
            elem.jomuinShukkinHms = ![undefined, null, ''].includes(elem.jomuinShukkinHms) ? (elem.jomuinShukkinHms).slice(0, 5) : ''
            elem.seikyuYoteiYmd = ![undefined, null, ''].includes(elem.seikyuYoteiYmd) ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
            elem.shiharaiYoteiYmd = ![undefined, null, ''].includes(elem.shiharaiYoteiYmd) ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''
            elem.jomuinShukkinYmd = ![undefined, null, ''].includes(elem.jomuinShukkinYmd) ? filter.dateFormatter(elem.jomuinShukkinYmd) : ''
            elem.jomuinShukkinHms = ![undefined, null, ''].includes(elem.jomuinShukkinHms) ? (elem.jomuinShukkinHms).slice(0, 5) : ''
            elem.jomuinTaikinYmd = ![undefined, null, ''].includes(elem.jomuinTaikinYmd) ? filter.dateFormatter(elem.jomuinTaikinYmd) : ''
            elem.jomuinTaikinHms = ![undefined, null, ''].includes(elem.jomuinTaikinHms) ? (elem.jomuinTaikinHms).slice(0, 5) : ''
            elem.jomuinKosokuJikanHm = ![undefined, null, ''].includes(elem.jomuinKosokuJikan) ? filter.minToIntervalTimeFormatter(elem.jomuinKosokuJikan) : ''
            elem.jomuinKyukeiJikanHm = ![undefined, null, ''].includes(elem.jomuinKyukeiJikan) ? filter.minToIntervalTimeFormatter(elem.jomuinKyukeiJikan) : ''
            elem.jomuinKadouJikanHm = ![undefined, null, ''].includes(elem.jomuinKadouJikan) ? filter.minToIntervalTimeFormatter(elem.jomuinKadouJikan) : ''
            elem.joshuShukkinYmd = ![undefined, null, ''].includes(elem.joshuShukkinYmd) ? filter.dateFormatter(elem.joshuShukkinYmd) : ''
            elem.joshuShukkinHms = ![undefined, null, ''].includes(elem.joshuShukkinHms) ? (elem.joshuShukkinHms).slice(0, 5) : ''
            elem.joshuTaikinYmd = ![undefined, null, ''].includes(elem.joshuTaikinYmd) ? filter.dateFormatter(elem.joshuTaikinYmd) : ''
            elem.joshuTaikinHms = ![undefined, null, ''].includes(elem.joshuTaikinHms) ? (elem.joshuTaikinHms).slice(0, 5) : ''
            elem.joshuKosokuJikanHm = ![undefined, null, ''].includes(elem.joshuKosokuJikan) ? filter.minToIntervalTimeFormatter(elem.joshuKosokuJikan) : ''
            elem.joshuKyukeiJikanHm = ![undefined, null, ''].includes(elem.joshuKyukeiJikan) ? filter.minToIntervalTimeFormatter(elem.joshuKyukeiJikan) : ''
            elem.joshuKadouJikanHm = ![undefined, null, ''].includes(elem.joshuKadouJikan) ? filter.minToIntervalTimeFormatter(elem.joshuKadouJikan) : ''
            elem.jissekiShukkoYmd = ![undefined, null, ''].includes(elem.jissekiShukkoYmd) ? filter.dateFormatter(elem.jissekiShukkoYmd) : ''
            elem.jissekiShukkoHms = ![undefined, null, ''].includes(elem.jissekiShukkoHms) ? (elem.jissekiShukkoHms).slice(0, 5) : ''
            elem.jissekiKikoYmd = ![undefined, null, ''].includes(elem.jissekiKikoYmd) ? filter.dateFormatter(elem.jissekiKikoYmd) : ''
            elem.jissekiKikoHms = ![undefined, null, ''].includes(elem.jissekiKikoHms) ? (elem.jissekiKikoHms).slice(0, 5) : ''

            const y = index + 1
            elem.seikyuKingakuGokeiFormula = `=P${y}+Q${y}+R${y}`
            elem.shiharaiKingakuGokeiFormula = `=V${y}+W${y}`

            return elem
          })
          self.rows = resultData

          // 検索条件設定
          var unkoYmdFromTo = ![undefined, null, ''].includes(self.conditions.unkoYoteiStartYmdString) ? self.conditions.unkoYoteiStartYmdString.slice(-5) : ''
          unkoYmdFromTo = unkoYmdFromTo + (![undefined, null, ''].includes(self.conditions.unkoYoteiEndYmdString) ? '～' + self.conditions.unkoYoteiEndYmdString.slice(-5) : '')
          self.conditions.unkoYmdFromTo = unkoYmdFromTo
          self.conditions.haishaEigyoshoNm = ![undefined, null, ''].includes(self.conditions.haishaEigyoshoId) ? indexeddb.getRecord(self.eigyoshoList, self.conditions.haishaEigyoshoId).eigyoshoNm : ''
          self.conditions.tokuisakiNm = ![undefined, null, ''].includes(self.conditions.tokuisakiId) ? indexeddb.getRecord(self.torihikisakiList, self.conditions.tokuisakiId).torihikisakiNm : ''
          self.conditions.yoshasakiNm = ![undefined, null, ''].includes(self.conditions.hacchusakiId) ? indexeddb.getRecord(self.torihikisakiList, self.conditions.hacchusakiId).torihikisakiNm : ''
          self.conditions.jomuinJininNm = ![undefined, null, ''].includes(self.conditions.jomuinJininId) ? indexeddb.getRecord(self.eigyoshoJininList, self.conditions.jomuinJininId).jininNmSei : ''
          self.conditions.jidoshaHyojiNm = ![undefined, null, ''].includes(self.conditions.sharyoId) ? indexeddb.getRecord(self.sharyoList, self.conditions.sharyoId).jidoshaHyojiNm : ''
          self.conditions.juchuEigyoshoNm = ![undefined, null, ''].includes(self.conditions.juchuEigyoshoId) ? indexeddb.getRecord(self.eigyoshoList, self.conditions.juchuEigyoshoId).eigyoshoNm : ''
          self.conditions.mstHinmeiNm = ![undefined, null, ''].includes(self.conditions.mstHinmeiId) ? indexeddb.getRecord(self.hinmeiList, self.conditions.mstHinmeiId).hinmeiNm : ''

          self.isConditionHide = true
        },
        isNoMessageModeMethod: function () {
          return noMessage
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureValidateMethod: function () {
          self.torikomiConditonsRequired = true
          self.tableRowRequired = true
        }
      }
      this.search(opt)
    },
    // 検索前チェック
    searchValidate: function () {
      return true
    },

    // 登録前チェック
    registerValidate: function () {
      return true
    },

    /**
     * 一覧ヘッダ作成
     */
    setHeader: function () {
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        const target = filter.dateFormatter(new Date())

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 営業所
        var wkEigyoshoList = ['未選択']
        const mEigyoshoLisst = this.eigyoshoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
        })
        const tEigyoshoList = mEigyoshoLisst.map(elem => {
          return elem.eigyoshoNm
        })
        wkEigyoshoList = wkEigyoshoList.concat(tEigyoshoList)

        // 配車先
        var wkHaishasakiList = ['自社', '傭車']

        // 乗務員
        var wkJomuinList = ['未選択']
        const mJomuinList = this.eigyoshoJininList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
        })
        const tJomuinList = mJomuinList.map(elem => {
          return elem.jininNmSei
        })
        wkJomuinList = wkJomuinList.concat(tJomuinList)

        // 車両
        var wkSharyoList = ['未選択']
        const mSharyoList = this.sharyoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })
        const tSharyoList = mSharyoList.map(elem => {
          return elem.jidoshaHyojiNm
        })
        wkSharyoList = wkSharyoList.concat(tSharyoList)

        // 傭車先
        var wkYoshasakiList = ['未選択']
        const mYoshasakiList = this.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
        })
        const tYoshasakiList = mYoshasakiList.map(elem => {
          return elem.torihikisakiNm
        })
        wkYoshasakiList = wkYoshasakiList.concat(tYoshasakiList)

        // 得意先
        var wkTokuisakiList = ['未選択']
        const mTokuisakiList = this.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
        })
        const tTokuisakiList = mTokuisakiList.map(elem => {
          return elem.torihikisakiNm
        })
        wkTokuisakiList = wkTokuisakiList.concat(tTokuisakiList)

        // 発着地
        var wkHacchakuchiList = ['未選択']
        const mHacchakuchiList = this.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tHacchakuchiList = mHacchakuchiList.map(elem => {
          return elem.hacchakuchiNm
        })
        wkHacchakuchiList = wkHacchakuchiList.concat(tHacchakuchiList)

        // 商品
        var wkShohinList = ['未選択']
        const mShohinList = this.hinmeiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tShohinList = mShohinList.map(elem => {
          return elem.hinmeiNm
        })
        wkShohinList = wkShohinList.concat(tShohinList)

        // 単位
        var wkTaniShubetsuList = ['未選択']
        const mTaniShubetsuList = this.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SVI001' && elem.kaishaCd === this.currentKaishaCode
        })
        const tTaniShubetsuList = mTaniShubetsuList.map(elem => {
          return elem.sbtNm
        })
        wkTaniShubetsuList = wkTaniShubetsuList.concat(tTaniShubetsuList)

        // 運賃計算区分
        var wkUnchinKeisanKubunList = ['未選択']
        const mUnchinKeisanKubunList = this.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === this.currentKaishaCode && ['01', '02', '03'].includes(elem.code)
        })
        const tUnchinKeisanKubunList = mUnchinKeisanKubunList.map(elem => {
          return elem.codeNm
        })
        wkUnchinKeisanKubunList = wkUnchinKeisanKubunList.concat(tUnchinKeisanKubunList)

        // 請求車種
        var wkShashuList = ['未選択']
        const mShashuList = this.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'GVI011' && elem.kaishaCd === this.currentKaishaCode
        })
        const tShashuList = mShashuList.map(elem => {
          return elem.sbtNm
        })
        wkShashuList = wkShashuList.concat(tShashuList)

        // --------------------------------------------------------------------------------
        // スプレッド用ヘッダ作成
        // --------------------------------------------------------------------------------
        self.headers = [
          // 共通部分
          // { title: '', name: 'id', type: 'hidden' },
          // { title: '', name: 'rowNo', type: 'hidden' },
          // { title: '区分', name: 'memo', type: 'text', customInput: null, readOnly: true, width: '40px' },
          // { title: '変更', name: 'editFlg', type: 'checkbox', customInput: null, width: '35px' },
          // { title: '', name: 'errFlg', type: 'hidden' },
          // { title: '削除', name: 'delFlg', type: 'checkbox', customInput: null, width: '35px' },
          // { title: '関連', name: 'relation', type: 'text', customInput: null, readOnly: true, width: '35px' }
        ]

        // マスタ情報から自動生成
        self.xlsImportMappingList.filter(function (elem) {
          return elem.formatCd === 'D2PRMD0030'
        }).sort((a, b) => {
          if (a.columnNo - b.columnNo !== 0) { return a.columnNo - b.columnNo }
          return -1
        }).forEach((elem) => {
          var dropdownList = null
          if (elem.source === 'EigyoshoList') {
            dropdownList = wkEigyoshoList
          } else if (elem.source === 'HaishasakiKbnList') {
            dropdownList = wkHaishasakiList
          } else if (elem.source === 'YoshasakiList') {
            dropdownList = wkYoshasakiList
          } else if (elem.source === 'JininList') {
            dropdownList = wkJomuinList
          } else if (elem.source === 'SharyoList') {
            dropdownList = wkSharyoList
          } else if (elem.source === 'TokuisakiList') {
            dropdownList = wkTokuisakiList
          } else if (elem.source === 'HacchakuchiList') {
            dropdownList = wkHacchakuchiList
          } else if (elem.source === 'ShohinList') {
            dropdownList = wkShohinList
            self.isShowCondition = true
          } else if (elem.source === 'TaniSbtList') {
            dropdownList = wkTaniShubetsuList
          } else if (elem.source === 'UnchinKeisanKbnList') {
            dropdownList = wkUnchinKeisanKubunList
          } else if (elem.source === 'ShashuSbtList') {
            dropdownList = wkShashuList
          }

          self.headers.push({
            title: elem.columnNm,
            name: elem.bindItemNm,
            type: elem.standardInputFlg !== true ? null : elem.inputType,
            customInput: elem.standardInputFlg === true ? null : elem.inputType,
            validateType: elem.validateType,
            required: elem.requiredFlg,
            readOnly: elem.readonlyFlg,
            autocomplete: elem.autocompleteFlg,
            width: elem.width + 'px',
            source: dropdownList,
            align: elem.align,
            mask: elem.inputSuffix,
            validateIntDigit: elem.inputIntDigit,
            validateDecimalDigit: elem.inputDecimalDigit,
            headerStyle: elem.headerStyle === null ? undefined : elem.headerStyle,
            columnNo: elem.columnNo
          })
        })

        resolve()
      })
    },

    /**
     *
     */
    rowAppendByContext: function (pos) {
      // 前行の運行実績IDを取り纏め
      var newrow = Object.assign([], this.rows[pos])

      newrow = {
        ...newrow,
        rowNo: this.rows.length + 1,
        id: this.rows[pos].id * -1, // 新規扱いとするため、マイナスにする。最終的にはcollectTrUnkoJissekiIdを使用。
        memo: '',
        editFlg: false,
        errFlg: false,
        editMode: false,
        relation: '△',

        // 受注キー初期化
        trJuchuKihonId: -1,
        trJuchuKihonKingakuId: -1,
        trJuchuMeisaiId: -1,
        trJuchuMeisaiKingakuId: -1,
        trJuchuHinmokuId: -1,
        trJuchuHinmokuKingakuId: -1,
        trSagyoMeisaiId: -1,
        trSagyoMeisaiKingakuId: -1,
        trSagyoHinmokuId: -1,
        trSagyoHinmokuKingakuId: -1,
        trHacchuKihonId: -1,
        trHacchuKihonKingakuId: -1,
        trHacchuMeisaiId: -1,
        trHacchuMeisaiKingakuId: -1,
        trHacchuHinmokuId: -1,
        trHacchuHinmokuKingakuId: -1,

        // 受注
        juchuNo: null,
        juchuEigyoshoNm: null,
        tokuisakiNm: null,
        chmonNo: null,
        hatsuchiNm: null,
        hatsuchiYmd: null,
        hatsuchiHms: null,
        chakuchiNm: null,
        chakuchiYmd: null,
        chakuchiHms: null,
        hinmeiNm: null,
        juchuSuryo: null,
        unitKbnNm: null,
        juchuJuryo: null,
        tanka: null,
        seikyuYoteiYmd: null,
        unchinKeisanKbnNm: null,
        seikyuShashuSbtNm: null,
        kihonUnchin: null,
        hiwayPrice: null,
        unchinHokaKingaku: null,
        unchinHokaHikazei: null,
        jikanWarimashiKingaku: null,
        kyoriWarimashiKingaku: null,
        warimashiSonotaKingsku: null,
        seikyuKingakuGokei: null,
        seikyuBiko: null,
        shiharaiYoteiYmd: null,
        yoshaKihonUnchin: null,
        yoshaHiwayPrice: null,
        yoshaUnchinHokaKingaku: null,
        yoshaUnchinHokaHikazei: null,
        shiharaiKingakuGokei: null
      }
      this.rows.splice(pos + 1, 0, newrow)
    },
    setReadonlyCell: function (rowData, columnName, rowIndex) {
      if (this.isShoukaiMode) {
        return true
      }
      if (rowIndex > 0) {
        if (columnName === 'unkoYmd' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
        if (columnName === 'haishaEigyoshoNm' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
        if (columnName === 'haishaKbnNm' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
        if (columnName === 'jomuinJininNm' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
        if (columnName === 'joshuJininNm' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
        if (columnName === 'jidoshaHyojiNm' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
        if (columnName === 'hacchusakiNm' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
        if (columnName === 'hacchusakiShaban' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
        if (columnName === 'hacchusakiShashuSbt' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
        if (columnName === 'sagyoNaiyoBiko' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
        if (columnName === 'unkoJissekiNo' && rowData.unkoJissekiNo === this.rows[rowIndex - 1].unkoJissekiNo) {
          return true
        }
      }

      return false
    },

    // 行追加
    rowAppend: function (num) {
      const userEigyoshoNm = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).eigyoshoNm

      for (let i = 0; i < num; i++) {
        this.wkUnkoJissekiId -= 1
        const newrow = {
          rowNo: this.rows.length + 1,
          id: this.wkUnkoJissekiId,
          trSagyoJissekiId: this.wkUnkoJissekiId,
          trKintaiJissekiId1: this.wkUnkoJissekiId,
          trKintaiJissekiId2: this.wkUnkoJissekiId,
          editFlg: false,
          errFlg: false,
          editMode: false,
          relation: '▼',
          CollectTrUnkoJissekiId: this.wkUnkoJissekiId,
          // 運行実績
          unkoJissekiNo: null,
          unkoYmd: date.getCurrentDate(),
          haishaEigyoshoNm: userEigyoshoNm,
          haishaKbnNm: '自社',
          hacchusakiNm: null,
          jomuinJininNmSei: null,
          joshuJininNmSei: null,
          jidoshaHyojiNm: null,
          jissekiShukkoYmd: null,
          jissekiShukkoHms: null,
          jissekiKikoYmd: null,
          jissekiKikoHms: null,
          hatsuchiOdoMater: null,
          chakuchiOdoMater: null,
          sokoKyori: null,
          kushaKyori: null,
          jisshaKyori: null,
          sosekisairyo: null,
          // 受注
          juchuNo: null,
          juchuEigyoshoNm: userEigyoshoNm,
          tokuisakiNm: null,
          chmonNo: null,
          hatsuchiNm: null,
          hatsuchiYmd: null,
          hatsuchiHms: null,
          chakuchiNm: null,
          chakuchiYmd: null,
          chakuchiHms: null,
          hinmeiNm: null,
          juchuSuryo: null,
          unitKbnNm: null,
          juchuJuryo: null,
          tanka: null,
          seikyuYoteiYmd: null,
          unchinKeisanKbnNm: '車建',
          seikyuShashuSbtNm: null,
          kihonUnchin: null,
          hiwayPrice: null,
          unchinHokaKingaku: null,
          unchinHokaHikazei: null,
          jikanWarimashiKingaku: null,
          kyoriWarimashiKingaku: null,
          warimashiSonotaKingsku: null,
          seikyuKingakuGokei: null,
          seikyuBiko: null,
          shiharaiYoteiYmd: null,
          yoshaKihonUnchin: null,
          yoshaHiwayPrice: null,
          yoshaUnchinHokaKingaku: null,
          yoshaUnchinHokaHikazei: null,
          shiharaiKingakuGokei: null,
          // 乗務員勤怠
          jomuinShukkinYmd: null,
          jomuinShukkinHms: null,
          jomuinTaikinYmd: null,
          jomuinTaikinHms: null,
          jomuinKosokuJikan: null,
          jomuinKyukeiJikan: null,
          jomuinKadouJikan: null,
          // 同乗者勤怠
          joshuShukkinYmd: null,
          joshuShukkinHms: null,
          joshuTaikinYmd: null,
          joshuTaikinHms: null,
          joshuKosokuJikan: null,
          joshuKyukeiJikan: null,
          joshuKadouJikan: null
        }
        this.rows.push(newrow)
      }
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
    },

    /**
     * スプレッドシート変更後イベント
     * @param {*} rowData
     * @param {*} cell
     * @param {*} x
     * @param {*} y
     * @param {*} newValue
     * @param {*} oldValue
     */
    changeAfter (rowData, cell, x, y, newValue, oldValue) {
      // console.log('c', rowData, cell, x, y, newValue, oldValue)
      const keyInfo = this.rows[y].unkoJissekiNo
      const changeColumnNm = this.headers[x].name
      const changeColumnNo = this.headers[x].columnNo

      console.log('change After :', keyInfo, '/', changeColumnNm, 'x is ', x, ', y is ', y, ', value is ', oldValue, ' -> ', newValue)

      // 実績周りのカラムの場合、同一運行実績Noは全て変更扱いにする
      if (changeColumnNo < 400 || changeColumnNo > 900) {
        this.rows.filter(x => x.unkoJissekiNo === keyInfo).map(x => {
          x[changeColumnNm] = newValue
          x.editFlg = true
          return x
        })
      }
    },

    /**
     * 保存処理（ソースが酷いのでそのうち直す）
     * @returns
     */
    onMultiSaveButtonClick: function () {
      const self = this

      // 変更フラグONのみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true
      })
      if (saveTargetRow.length < 1) { return }

      // DB保存用変換
      saveTargetRow.map((elem) => {
        // HHMMから秒に変換
        elem.jomuinKosokuJikan = ![null, ''].includes(elem.jomuinKosokuJikanHm) ? filter.timeToMinFormatter(elem.jomuinKosokuJikanHm) : null
        elem.jomuinKyukeiJikan = ![null, ''].includes(elem.jomuinKyukeiJikanHm) ? filter.timeToMinFormatter(elem.jomuinKyukeiJikanHm) : null
        elem.jomuinKadouJikan = ![null, ''].includes(elem.jomuinKadouJikanHm) ? filter.timeToMinFormatter(elem.jomuinKadouJikanHm) : null
        elem.joshuKosokuJikan = ![null, ''].includes(elem.joshuKosokuJikanHm) ? filter.timeToMinFormatter(elem.joshuKosokuJikanHm) : null
        elem.joshuKyukeiJikan = ![null, ''].includes(elem.joshuKyukeiJikanHm) ? filter.timeToMinFormatter(elem.joshuKyukeiJikanHm) : null
        elem.joshuKadouJikan = ![null, ''].includes(elem.joshuKadouJikanHm) ? filter.timeToMinFormatter(elem.joshuKadouJikanHm) : null

        // 数値変換
        elem.hatsuchiOdoMater = ![null, ''].includes(elem.hatsuchiOdoMater) ? d2fmt.removeComma(elem.hatsuchiOdoMater) : null
        elem.chakuchiOdoMater = ![null, ''].includes(elem.chakuchiOdoMater) ? d2fmt.removeComma(elem.chakuchiOdoMater) : null
        elem.sokoKyori = ![null, ''].includes(elem.sokoKyori) ? d2fmt.removeComma(elem.sokoKyori) : null
        elem.kushaKyori = ![null, ''].includes(elem.kushaKyori) ? d2fmt.removeComma(elem.kushaKyori) : null
        elem.jisshaKyori = ![null, ''].includes(elem.jisshaKyori) ? d2fmt.removeComma(elem.jisshaKyori) : null
        elem.sosekisairyo = ![null, ''].includes(elem.sosekisairyo) ? d2fmt.removeComma(elem.sosekisairyo) : null
        elem.juchuSuryo = ![null, ''].includes(elem.juchuSuryo) ? d2fmt.removeComma(elem.juchuSuryo) : null
        elem.juchuJuryo = ![null, ''].includes(elem.juchuJuryo) ? d2fmt.removeComma(elem.juchuJuryo) : null
        elem.kihonUnchin = this.convertOutputStringToDecimal(elem.kihonUnchin)
        elem.tanka = ![null, ''].includes(elem.tanka) ? d2fmt.removeComma(elem.tanka) : null
        elem.hiwayPrice = ![null, ''].includes(elem.hiwayPrice) ? d2fmt.removeComma(elem.hiwayPrice) : null
        elem.unchinHokaKingaku = ![null, ''].includes(elem.unchinHokaKingaku) ? d2fmt.removeComma(elem.unchinHokaKingaku) : null
        elem.unchinHokaHikazei = ![null, ''].includes(elem.unchinHokaHikazei) ? d2fmt.removeComma(elem.unchinHokaHikazei) : null
        elem.jikanWarimashiKingaku = ![null, ''].includes(elem.jikanWarimashiKingaku) ? d2fmt.removeComma(elem.jikanWarimashiKingaku) : null
        elem.kyoriWarimashiKingaku = ![null, ''].includes(elem.kyoriWarimashiKingaku) ? d2fmt.removeComma(elem.kyoriWarimashiKingaku) : null
        elem.warimashiSonotaKingsku = ![null, ''].includes(elem.warimashiSonotaKingsku) ? d2fmt.removeComma(elem.warimashiSonotaKingsku) : null
        elem.yoshaKihonUnchin = ![null, ''].includes(elem.yoshaKihonUnchin) ? d2fmt.removeComma(elem.yoshaKihonUnchin) : null
        elem.yoshaHiwayPrice = ![null, ''].includes(elem.yoshaHiwayPrice) ? d2fmt.removeComma(elem.yoshaHiwayPrice) : null
        elem.yoshaUnchinHokaKingaku = ![null, ''].includes(elem.yoshaUnchinHokaKingaku) ? d2fmt.removeComma(elem.yoshaUnchinHokaKingaku) : null
        elem.yoshaUnchinHokaHikazei = ![null, ''].includes(elem.yoshaUnchinHokaHikazei) ? d2fmt.removeComma(elem.yoshaUnchinHokaHikazei) : null
        elem.seikyuKingakuGokei = this.convertOutputStringToDecimal(elem.seikyuKingakuGokei)
        elem.shiharaiKingakuGokei = this.convertOutputStringToDecimal(elem.shiharaiKingakuGokei)

        return elem
      })

      /**
       * リスト項目テキスト⇒ID/Code変換
       */
      // 配車営業所変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null, ''].includes(elem.haishaEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm === elem.haishaEigyoshoNm
        })
        if (m.length > 0) {
          elem.haishaEigyoshoId = m[0].id
        }
        return elem
      })

      // 売上営業所変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.juchuEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm === elem.juchuEigyoshoNm
        })
        if (m.length > 0) {
          elem.juchuEigyoshoId = m[0].id
        } else {
          elem.juchuEigyoshoId = null
        }
        return elem
      })

      // 配車先
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.haishaKbnNm)
      }).map((elem) => {
        if (elem.haishaKbnNm === '自社') {
          elem.haishaKbn = '02'
        } else if (elem.haishaKbnNm === '傭車') {
          elem.haishaKbn = '03'
        } else {
          elem.haishaKbn = null
        }
        return elem
      })

      // 発注先
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hacchusakiNm)
      }).map((elem) => {
        const m = self.filteredHacchusakiList.filter(function (item) {
          return item.torihikisakiNm === elem.hacchusakiNm
        })
        if (m.length > 0) {
          elem.hacchusakiId = m[0].id
        } else {
          elem.hacchusakiId = null
        }
        return elem
      })

      // 傭車車種
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hacchusakiShashuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVI011' && item.sbtNm === elem.hacchusakiShashuSbtNm
        })
        if (m.length > 0) {
          elem.hacchusakiShashuSbt = m[0].sbtCd
        } else {
          elem.hacchusakiShashuSbt = null
        }
        return elem
      })

      // 乗務員
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.jomuinJininNm)
      }).map((elem) => {
        const m = self.filteredJininList.filter(function (item) {
          return item.jininNmSei === elem.jomuinJininNm
        })
        if (m.length > 0) {
          elem.jomuinJininId = m[0].id
        } else {
          elem.jomuinJininId = null
        }
        return elem
      })

      // 同乗者
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.joshuJininNm)
      }).map((elem) => {
        const m = self.filteredJininList.filter(function (item) {
          return item.jininNmSei === elem.joshuJininNm
        })
        if (m.length > 0) {
          elem.joshuJininId = m[0].id
        } else {
          elem.joshuJininId = null
        }
        return elem
      })

      // 車両変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.jidoshaHyojiNm)
      }).map((elem) => {
        const m = self.sharyoList.filter(function (item) {
          return item.jidoshaHyojiNm === elem.jidoshaHyojiNm
        })
        if (m.length > 0) {
          elem.sharyoId = m[0].id
        } else {
          elem.sharyoId = null
        }
        return elem
      })

      // 受注営業所変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.juchuEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm === elem.juchuEigyoshoNm
        })
        if (m.length > 0) {
          elem.juchuEigyoshoId = m[0].id
        } else {
          elem.juchuEigyoshoId = null
        }
        return elem
      })

      // 荷主
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.tokuisakiNm)
      }).map((elem) => {
        const m = self.filteredTokuisakiList.filter(function (item) {
          return item.torihikisakiNm === elem.tokuisakiNm
        })
        if (m.length > 0) {
          elem.tokuisakiId = m[0].id
        } else {
          elem.tokuisakiId = null
        }
        return elem
      })

      // 発地
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hatsuchiNm)
      }).map((elem) => {
        const m = self.filteredHacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm === elem.hatsuchiNm
        })
        if (m.length > 0) {
          elem.hatsuchiId = m[0].id
        } else {
          elem.hatsuchiId = null
        }
        return elem
      })

      // 着地
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.chakuchiNm)
      }).map((elem) => {
        const m = self.filteredHacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm === elem.chakuchiNm
        })
        if (m.length > 0) {
          elem.chakuchiId = m[0].id
        } else {
          elem.chakuchiId = null
        }
        return elem
      })

      // 商品
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hinmeiNm)
      }).map((elem) => {
        const m = self.filteredHinmeiList.filter(function (item) {
          return item.hinmeiNm === elem.hinmeiNm
        })
        if (m.length > 0) {
          elem.mstHinmeiId = m[0].id
        } else {
          elem.mstHinmeiId = null
        }
        return elem
      })

      // 単位
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.unitKbnNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SVI001' && item.sbtNm === elem.unitKbnNm
        })
        if (m.length > 0) {
          elem.unitKbn = m[0].sbtCd
        } else {
          elem.unitKbn = null
        }
        return elem
      })

      // 運賃計算区分
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.unchinKeisanKbnNm)
      }).map((elem) => {
        const m = self.kubunList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'SFF055' && item.codeNm === elem.unchinKeisanKbnNm
        })
        if (m.length > 0) {
          elem.unchinKeisanKbn = m[0].code
        } else {
          elem.unchinKeisanKbn = null
        }
        return elem
      })

      // 請求車種
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.seikyuShashuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVI011' && item.sbtNm === elem.seikyuShashuSbtNm
        })
        if (m.length > 0) {
          elem.seikyuShashuSbt = m[0].sbtCd
        } else {
          elem.seikyuShashuSbt = null
        }
        return elem
      })

      /**
       * 保存処理
       */
      this.targetList = saveTargetRow
      this.$nextTick(function () {
        self.saveAction()
      })
    },

    saveAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/VwCD2prmd0030/RegisterMulti', self.targetList)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()

            this.$nextTick(function () {
              this.searchAction(true)
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    convertOutputStringToDecimal: function (val) {
      if ([undefined, null, ''].includes(val)) return null
      if (!isNaN(val)) return val
      return d2fmt.removeComma(val.replace(' 円', ''))
    },

    /**
     * EXCEL出力
     */
    onXlsOutputButtonClick: function (e) {
      var idList = []
      this.rows.forEach((x) => {
        idList.push(x.id)
      })
      const outputInfo = {
        idList: idList
      }

      this.Effects.loadStart()

      const self = this
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2prmd0030/ExcelOutput', outputInfo)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          self.Effects.loadComplete()
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '日報一覧_' + ts + '.xlsx'
          elem.click()
        })
    },

    /**
     * テンプレートEXCELダウンロード
     */
    onClickDownloadTemplate: function () {
      this.HttpClient
        .requestFileByPost('/api/v1/MstXlsImportMapping/TemplateDownload')
        .then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = 'template.xlsx'
          elem.click()
        })
    },

    /**
     * 検索簡易表示用
     */
    getItemValue: function (item) {
      console.log('getItemValue', this.conditions, item)
      if (!item.showValue) return ''

      if (item.convertValue === true) {
        return this.getItemValueFromMasterData(item)
      } else {
        if ([undefined, null].includes(item.value)) return ''

        const dotIndex = item.value.indexOf('.')
        if (dotIndex > 0) {
          const itemArray = item.value.split('.')
          console.log(this.conditions[itemArray[0]][itemArray[1]])
          return this.conditions[itemArray[0]][itemArray[1]]
        } else {
          return this.conditions[item.value]
        }
      }
    },
    getItemValueFromMasterData: function (item) {
      var rtnVal = ''
      const self = this
      if (item.master === 'msteigyosho') {
        const m = self.eigyoshoList.filter((elem) => {
          return (elem.id === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].eigyoshoNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msttorihikisaki') {
        const m = self.torihikisakiList.filter((elem) => {
          return (elem.id === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].torihikisakiNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'mstsharyo') {
        const m = self.sharyoList.filter((elem) => {
          return (elem.id === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].jidoshaHyojiNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'mstjinin') {
        const m = self.eigyoshoJininList.filter((elem) => {
          return (elem.id === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].jininNmSei
        } else {
          rtnVal = ''
        }
      }
      return rtnVal
    }
  }
}
